import {
  CLOSE_TAX_CARD_SNACKBAR,
  CLOSE_TAX_CARD_ERROR_SNACKBAR,
  CLOSE_TAX_CARD_SPINNER,
  GET_YEL_SUCCESS,
  GET_YEL_FAILED,
  PASSWORD_UPDATE_SUCCESS,
  PASSWORD_UPDATE_FAILED,
  CLOSE_PASSWORD_SNACKBAR,
  YEL_UPDATE_SUCCESS,
  YEL_UPDATE_FAILED,
  CLOSE_YEL_SNACKBAR,
  ENABLE_YEL_INCOME_LOCK,
  ENABLE_YEL_SELECTION_LOCK,
  UPDATE_TAX_CARD,
  UPDATE_TAX_CARD_SUCCESS,
  UPDATE_TAX_CARD_FAILED,
  LOCATION_CHANGE
} from '../constants'

const initialState = {
  showTaxCardSpinner: false,
  showTaxCardSnackbar: false,
  showTaxCardErrorSnackbar: false,
  yel: [],
  showSnackbar: false,
  showFailSnackbar: false,
  showYelSnackbar: false,
  isYelIncomeLock: false,
  isYelSelectionLock: false
}

const taxReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TAX_CARD:
      return Object.assign(
        {},
        { ...state },
        {
          showTaxCardSpinner: action.disableLoader ? false : true,
          noTaxCardFound: false
        }
      )

    case UPDATE_TAX_CARD_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showTaxCardSpinner: false,
          showTaxCardSnackbar: action.disableSnackbar ? false : true
        }
      )

    case UPDATE_TAX_CARD_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showTaxCardSpinner: false,
          showTaxCardErrorSnackbar: action.disableSnackbar ? false : true,
          noTaxCardFound: action.noTaxCardFound
        }
      )

    case CLOSE_TAX_CARD_SNACKBAR:
      return Object.assign({}, state, {
        showTaxCardSnackbar: false
      })

    case CLOSE_TAX_CARD_ERROR_SNACKBAR:
      return Object.assign({}, state, {
        showTaxCardErrorSnackbar: false
      })

    case CLOSE_TAX_CARD_SPINNER:
      return Object.assign({}, state, {
        showTaxCardSpinner: false
      })

    case GET_YEL_SUCCESS:
      return Object.assign({}, { ...state }, { yel: action.yels.data })

    case GET_YEL_FAILED:
      return Object.assign({}, { ...state }, {})

    case PASSWORD_UPDATE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: true
        }
      )

    case PASSWORD_UPDATE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showFailSnackbar: true
        }
      )

    case CLOSE_PASSWORD_SNACKBAR:
      return Object.assign({}, state, {
        showSnackbar: false,
        showFailSnackbar: false
      })

    case YEL_UPDATE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showYelSnackbar: true
        }
      )

    case YEL_UPDATE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showYelFailSnackbar: true
        }
      )

    case CLOSE_YEL_SNACKBAR:
      return Object.assign({}, state, {
        showYelSnackbar: false
      })

    case ENABLE_YEL_INCOME_LOCK:
      return Object.assign({}, state, {
        isYelIncomeLock: true
      })

    case ENABLE_YEL_SELECTION_LOCK:
      return Object.assign({}, state, {
        isYelSelectionLock: true
      })

    case LOCATION_CHANGE:
      return Object.assign({}, state, {
        showTaxCardSpinner: false,
        showTaxCardSnackbar: false,
        showTaxCardErrorSnackbar: false
      })

    default:
      return state
  }
}

export default taxReducer
